import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

import { GenerateQuotePage } from '#/modules/quote/back-office/generate-quote/generate-quote-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

const generateQuoteSearchSchema = type({ 'run_id?': 'string' })

export const Route = createFileRoute('/bo/subscriptions/generate')({
  beforeLoad: ({ context }) => requirePermissions(context, ['subscription.create']),
  component: GenerateQuotePage,
  validateSearch: generateQuoteSearchSchema,
})
